export default "__VITE_ASSET__DdTARdmj__"